module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Condensed.aa69b4f.woff2";